<template>
  <!--最外层包裹-->
  <div class="wrap">
    <Topnav></Topnav>
    <div class="mj-imgherf">
      <div class="mj-imgherf-top">
        <div>
          <div></div>
          <a  href="http://yinglie.chinamartyrs.gov.cn/lieshijinianguan/" target="_blank">
            主题公祭
          </a>
        </div>
        <div>
          <div></div>
          <a  href="http://yinglie.chinamartyrs.gov.cn/LingYuanZhanShi/lingyuan/vrlist.html" target="_blank">
            线上瞻仰
          </a>
        </div>
      </div>
      <div class="mj-imgherf-but">
        <p class="mj-imgherf-but-title">
          第三批国家级抗战纪念设施、遗址
          <br>
          和著名抗日英烈、英雄群体名录公布
        </p>
      </div>
    </div>
    <ul class="mj-list" v-show="datalist.length>0">
       <li class="mj-list-item" v-for="(item,index) in datalist" :key="index">
         <div class="mj-list-item-img" @touchend.prevent="handleHerf(item.basicId)">
           <img :src=item.basicThumbnail alt="">
         </div>
         <p class="mj-list-item-text text-tow-overflow" @touchend.prevent="handleHerf(item.basicId)"  v-html="item.basicTitle" :title=item.basicTitle>
           {{item.basicTitle}}
         </p>
       </li>
       <paging :dataall="rememberpage.all" :dataCur="rememberpage.cur" :datanum="rememberpage.num" :dataDatanum="rememberpage.dataNum"
              @change="pageChange"></paging>
    </ul>
    <div class="mj-datazw" v-show="datalist.length<=0">
      暂无数据
    </div>
  </div>
</template>
<script>

</script>
<script>
  import {REMEMBER} from '@/config/global.js'
  import util from '@/assets/js/util'
  import {getUserToken} from '@/config/config.js'
  import Paging from '@/components/paging'
  import Topnav from '@/components/topnav.vue'
  import {getmjlsJsondata,getmjlsAjaxdata} from '@/api/rememberhistory.js'
  export default {
    data() {
      return {
        remember:{},
        datalist:[],
        rememberpage: {
          all: '', //总页数
          cur: 1, //当前页码
          num: 6, //一页显示的数量  必须是奇数
          dataNum: '', //数据的数量
        },
      }
    },
    components: {
      Paging,
      Topnav
    },
    mounted() {
      getUserToken()
      util.stopTouchendPropagationAfterScroll();
     this._initdata()
    },
    methods: {
      _initdata(){
        if (util.isEmpty(this.remember)) {
          getmjlsJsondata().then(res => {
              if (res.length > 0) {
                if (!util.isEmpty(res)) {
                  this.remember = util.getJsonDetails(res,this.rememberpage.num);
                  this.datalist = this.remember['1'];
                  this.rememberpage.dataNum = res[0].pageSize;
                  this.rememberpage.all = Math.ceil(res[0].pageSize/this.rememberpage.num)
                } else {

                }
              }else {

              }
            }
          ).catch((err) => {
            this.isdata =true
          })
        }
      },
      pageChange: function (page) {
        this.rememberpage.cur = page;
        let data = {
          pageSize: this.rememberpage.num,
          pageNum: this.rememberpage.cur,
          columnId: REMEMBER
        };
        if (!this.remember[page] || this.remember[page].length < this.rememberpage.num) {
          getmjlsAjaxdata(data).then((res) => {
            if (res.code == 200 && res.rows) {
              if (res.rows.length > 0) {
                this.datalist = res.rows
              }else {

              }
            }
          }).catch(() => {

          })
        } else {
          this.datalist = this.remember[page];
        }
      },
      handleHerf(id) {
        let two = this.$router.resolve({
          path: `/Details/${id}&&2`,
        })
        window.open(two.href, '_blank');
      }

    }
  }
</script>
<style lang="scss" scoped>
  @import "index.scss";
</style>





// WEBPACK FOOTER //
// src/pages/Remember/index.vue